import { type FeedbackSendingMethod, feedbackSendingMethodSchema } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { useMemo } from 'react'
import { View } from 'react-native'
import { Body } from '~/components/typography/Content'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils'

export function FeedbackSendingMethodButtons({
  selectedMethod,
  onSelectMethod,
  disabled,
  description,
  className,
}: {
  selectedMethod: FeedbackSendingMethod
  onSelectMethod: (method: FeedbackSendingMethod) => void
  disabled?: boolean
  description?: string
  className?: string
}) {
  const { t } = useTranslations('feedback')
  const labels = useMemo(
    () =>
      ({
        sms: 'SMS',
        email: t(($) => $.requestFlow.sendMethodEmail),
      }) satisfies Record<FeedbackSendingMethod, string>,
    [t]
  )

  return (
    <View className={cn('gap-4', className)}>
      <Body className="mb-2 text-pretty px-2 text-center">
        {description ?? t(($) => $.requestFlow.sendMethodButtonDescription)}
      </Body>
      <View className={cn('flex-row flex-wrap items-center justify-center gap-3')}>
        {feedbackSendingMethodSchema.options.map((option) => (
          <Button
            key={option.value}
            testID={`feedback-send-method-${option.value}`}
            variant={selectedMethod === option.value ? 'default' : 'outline'}
            size="lg"
            onPress={() => onSelectMethod(option.value)}
            disabled={disabled}>
            {labels[option.value]}
          </Button>
        ))}
      </View>
    </View>
  )
}
